<div class="equis" (click)="onCancel()">X</div>
<h1 class="evento-title">Aventura de realidad aumentada</h1>
<div class="evento-line"></div>
<div class="evento-desc">
  Selecciona la opción de mundo virtual que más se ajuste a la experiencia que
  quieres ofrecer a tus clientes.
</div>

<div class="row cards">
  <div class="col-md-6 col-sm-12">
    <mat-card class="card-evento card">
      <div class="superior-line"></div>
      <mat-card-content>
        <p class="subtitle-evento">Aventura de realidad aumentada</p>
        <div class="inferior-line"></div>
        <p class="descripcion-evento">
          Activa tu aventura AR. Crea y personaliza estaciones y minijuegos
          para recibir a los visitantes. Permite que los asistentes
          completen las estaciones de la aventura buscando el marcador correspondiente, 
          ganando puntos y recibiendo recompensas
        </p>
        <img
          src="../../../../assets/images/imagen-yincana.jpg"
          alt=""
          class="img-evento"
        />
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-button
          class="btn btn-evento"
          (click)="openYincanaModal()"
        >
          Crear
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
